import { ApiGroup } from "../types/ApiTypes"

const SurgerySiteAPI: ApiGroup = {
    pagedList: {
        title: "수술부위 목록 조회",
        url: "/SurgerySite/PagedList",
        method: "POST",
        paramz: {},
    },
    getById: {
        title: "수술부위 상세 조회",
        url: "/SurgerySite/GetById/:seqId",
        method: "GET",
        paramz: {},
        pathParams: ["seqId"],
    },
    create: {
        title: "수술부위 등록",
        url: "/SurgerySite/Create",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "수술부위 수정",
        url: "/SurgerySite/Update/:seqId",
        method: "PUT",
        paramz: {},
        pathParams: ["seqId"],
    },
    delete: {
        title: "수술부위 삭제",
        url: "/SurgerySite/Delete/:seqId",
        method: "DELETE",
        paramz: {},
        pathParams: ["seqId"],
    },
}

export default SurgerySiteAPI
